var map = {
	"./AdaIDE.dark.png": 4446,
	"./AdaIDE.darkplus.png": 805,
	"./AdaIDE.default.png": 92392,
	"./AdaIDE.pink.png": 41194,
	"./CCmake.dark.png": 50172,
	"./CCmake.darkplus.png": 18754,
	"./CCmake.default.png": 36460,
	"./CCmake.pink.png": 6658,
	"./DiffofTwoCompilers.dark.png": 39797,
	"./DiffofTwoCompilers.darkplus.png": 63434,
	"./DiffofTwoCompilers.default.png": 37156,
	"./DiffofTwoCompilers.pink.png": 44691,
	"./DiffofTwoSources.dark.png": 7056,
	"./DiffofTwoSources.darkplus.png": 14891,
	"./DiffofTwoSources.default.png": 43512,
	"./DiffofTwoSources.pink.png": 87721,
	"./JavaIDE.dark.png": 44465,
	"./JavaIDE.darkplus.png": 5334,
	"./JavaIDE.default.png": 42920,
	"./JavaIDE.pink.png": 1154,
	"./LLVMIR.dark.png": 60181,
	"./LLVMIR.darkplus.png": 86874,
	"./LLVMIR.default.png": 70620,
	"./LLVMIR.pink.png": 40303,
	"./PascalIDE.dark.png": 58088,
	"./PascalIDE.darkplus.png": 11333,
	"./PascalIDE.default.png": 319,
	"./PascalIDE.pink.png": 98588,
	"./Preprocessor.dark.png": 52241,
	"./Preprocessor.darkplus.png": 49562,
	"./Preprocessor.default.png": 128,
	"./Preprocessor.pink.png": 40767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87456;